// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3kXtY","list":"BalanceDue_list__1g2UR","listRow":"BalanceDue_listRow__2BrGC","total":"BalanceDue_total__1OQOo"};